// extracted by mini-css-extract-plugin
module.exports = {"Outer":"NewPie_Outer__2Pahk","innerText":"NewPie_innerText__2zkXs","afterDecimal":"NewPie_afterDecimal__O5ysZ","pieCard":"NewPie_pieCard__3erfq"};